import { Text } from "../../Text/Text/Text";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { SkeletonIndicator } from "../../Indicator/SkeletonIndicator/SkeletonIndicator";
import styles from "./Note.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Note = function Note(_ref) {
  var headline = _ref.headline,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    text = _ref.text;
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      className: styles.skeletonWrapper,
      children: /*#__PURE__*/_jsx(SkeletonIndicator, {
        barWidths: ['20%', '80%'],
        size: "large"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeadingText, {
      align: "left",
      ariaLevel: 2,
      typog: "headline5",
      variant: "default",
      className: styles.noteHeadline,
      "data-e2e-name": "note_headline",
      children: headline
    }), /*#__PURE__*/_jsx("div", {
      className: styles.noteDetails,
      "data-e2e-name": "note_details",
      children: /*#__PURE__*/_jsx(Text, {
        className: styles.noteText,
        typog: "bodycopyLarge",
        children: text
      })
    })]
  });
};